<!-- ==== Preloader :: Start ==== -->
<div class="preloader--wrapper">
	<img src="assets/new-layout/img/preloader.svg" alt="preloader" />
</div>
<!-- ==== Preloader :: End ==== -->
<router-outlet></router-outlet>
